import { DisabledTag } from '@nile/mangifera/src/Pebbles/TicketContainer';
import { Modal, Button, RadioButton } from '@superops/ui-design-system';

import envConfig from '@nile/home/src/Config/env';
import { Save, Store } from '@styled-icons/fa-solid';
import styled from 'styled-components';
import {
  BackgroundIcon,
  getTranslatedText,
  DeleteModal,
  Icon
} from '@nile/components';
import {
  ClientSelect,
  UserSelect
} from '@nile/mangifera/src/Components/Ticket';
import React, { useState, useCallback } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

const IconHolder = styled.div`
  cursor: pointer;
`;

function ActionCell(props) {
  const { cell, intl } = props;
  const meta = cell?.row?.original;
  const { actions } = cell.column;
  const modalActivator = (
    <div className="action-button p-0">
      <Button id="genActionCell">
        <IconHolder className="deleteItem">
          <SVGIcon name="Delete" />
        </IconHolder>
      </Button>
    </div>
  );
  return (
    <>
      <div className="flex">
        <DeleteModal
          modalActivator={modalActivator}
          description={
            meta.module === 'CLIENT'
              ? getTranslatedText(intl, 'mail.unknown.delete.description')
              : getTranslatedText(intl, 'ticket.unknown.delete.description')
          }
          handleDeleteConfirmation={() => actions.onDelete(meta)}
          title={
            meta.module === 'CLIENT'
              ? getTranslatedText(intl, 'mail.unknown.delete.title')
              : getTranslatedText(intl, 'ticket.unknown.delete.title')
          }
        />
        <ClientConversationModal intl={intl} actions={actions} meta={meta} />
      </div>
    </>
  );
}

export const ClientConversationModal = (props) => {
  const { intl, actions, meta } = props;
  const [selectedClient, setSelectedClient] = useState(null);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [active, setActive] = useState(false);
  const toggleModal = useCallback(() => setActive((active) => !active), []);
  const [value, setValue] = useState('automatic');
  const [showRequester, setShowRequester] = useState(false);
  const ticket = {
    ...props,
    requester: {}
  };
  const name =
    (ticket?.requester?.firstName || '') + (ticket?.requester?.lastName || '');
  const stopEvents = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const activator = (
    <div className="action-button px-10 ml-10">
      <Button onClick={toggleModal}>
        <div className="flex actr">
          <IconHolder className="deleteItem mr8">
            <SVGIcon name="ClientLogo" />
          </IconHolder>
          <FormattedMessage id="mail.client.conversation.button" />
        </div>
      </Button>
    </div>
  );

  const handleChange = useCallback((_checked, newValue) => {
    setValue(newValue);
    setShowRequester(newValue === 'manual');
    // props.updatePolicy('executeForAllClients', value === 'clients');
  }, []);

  const updateField = (key, field) => {
    ticket.requester = key;
  };
  return (
    <Modal
      activator={activator}
      open={active}
      onClose={toggleModal}
      title={getTranslatedText(
        intl,
        meta.module === 'CLIENT'
          ? 'mail.client.conversation.title'
          : 'ticket.unkown.move.ticket.title'
      )}
      primaryAction={{
        content: (
          <div className="flex actr">
            <div className="flex actr mr10">
              <SVGIcon name="Save" />
            </div>
            {meta.module === 'CLIENT' ? (
              <FormattedMessage id="mail.client.conversation.save" />
            ) : (
              <FormattedMessage id="ticket.unkown.ticket.move.action" />
            )}
          </div>
        ),
        onAction: () => {
          selectedClient && meta.module === 'CLIENT'
            ? actions.onClickConvertClientConversation(meta, selectedClient)
            : actions.onClickConvertToTicket(
                meta,
                selectedClient,
                ticket.requester
              );
        }
      }}
    >
      <Modal.Section>
        {/* <Field onClick={stopEvents}> */}
        <div className="w280">
          <p className="label-color">
            {' '}
            <FormattedMessage id="asset.details.client.pl" />
          </p>
          <ClientSelect
            updateField={(_, val) => setSelectedClient(val)}
            property="accountId"
            value={selectedClient}
            selectedValue={selectedClient}
            icon={Store}
          />
        </div>
        {meta.module !== 'CLIENT' && selectedClient?.name && (
          <div>
            <div className="pt16">
              <RadioButton
                label={
                  `Create '${meta?.fromAddress}` +
                  "' as " +
                  `${selectedClient?.name}` +
                  ' user'
                }
                checked={value === 'automatic'}
                id="automatic"
                name="accounts"
                onChange={handleChange}
              />
            </div>
            <div className="pt16">
              <RadioButton
                label={getTranslatedText(
                  intl,
                  'ticket.unkown.ticket.select.requester'
                )}
                checked={value === 'manual'}
                id="manual"
                name="accounts"
                onChange={handleChange}
              />
            </div>
          </div>
        )}
        {showRequester && (
          <div className="w280">
            <p className="pt16 label-color">
              {' '}
              <FormattedMessage id="admin.Requesterrole.associate.header" />
            </p>
            <UserSelect
              fetchBefore
              client={selectedClient}
              updateField={(_, val) => updateField(val)}
              property="userId"
              field="requester"
              value={ticket.requester}
              defaultValue={name ? [{ name: name, label: name }] : []}
              icon={Store}
            />
          </div>
        )}
      </Modal.Section>
    </Modal>
  );
};

export default injectIntl(ActionCell);
